import { lazy } from 'react';




//sets the pages display settings

const SimpleActivationConfig = {
  settings: {
    layout: {
        style : 'layout1',
        config: {
          
            navbar : {
                display : false,
                
            },
            toolbar: {
                display : false,
            },
            footer : {
                display : false,
                
            },
            mode   : 'fullwidth'
        }
    },
    
},
  routes: [
    {
      path: '/activation/:code',
      component: lazy(() => import('./SimpleActivation')),
    },
  ],
};

export default SimpleActivationConfig
